var _defs, _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudiesPnas(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 280.3 103.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#0075c9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M316.55,280.8c0,15.6-11.7,25.3-30.4,25.3h-14.1v19.3h-16.2v-70h30.3C304.85,255.4,316.55,265.1,316.55,280.8Zm-16.4,0c0-7.7-5-12.2-14.9-12.2h-13.2v24.3h13.2C295.15,292.9,300.15,288.4,300.15,280.8Z",
    transform: "translate(-255.85 -254.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M390.25,255.4v70H377l-34.9-42.5v42.5h-16v-70h13.4l34.8,42.5V255.4Z",
    transform: "translate(-255.85 -254.2)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M453,310.4h-32.5l-6.2,15h-16.6l31.2-70h16l31.3,70h-17Zm-5.1-12.3-11.1-26.8-11.1,26.8Z",
    transform: "translate(-255.85 -254.2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M478,318.5l5.5-12.2a41.17,41.17,0,0,0,23.1,7.3c9.6,0,13.5-3.2,13.5-7.5,0-13.1-40.7-4.1-40.7-30.1,0-11.9,9.6-21.8,29.5-21.8,8.8,0,17.8,2.1,24.3,6.2l-5,12.3a39.54,39.54,0,0,0-19.4-5.5c-9.6,0-13.3,3.6-13.3,8,0,12.9,40.7,4,40.7,29.7,0,11.7-9.7,21.7-29.7,21.7C495.35,326.6,484.15,323.3,478,318.5Z",
    transform: "translate(-255.85 -254.2)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 87.41,
    width: 280.3,
    height: 16.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudiesPnas);
export default __webpack_public_path__ + "static/media/studies-PNAS.4252c2f22a6f0f98da929e4512f0f597.svg";
export { ForwardRef as ReactComponent };